import {
    ACCOUNTS_INSTANCE,
    EVENTCHAIN_INSTANCE,
    ORGANIZATION_INSTANCE,
    PASS_ORDER_INSTANCE,
    PLACES_INSTANCE
} from "@/helper/consts";

import Breadcrumbs from "@/modules/viewer/Breadcrumbs";
import names from "@/modules/viewer/routers/names";
import CarsBreadcrumbs from "@/modules/viewer/cars/CarsBreadcrumbs";
import FieldsBreadcrumbs from "@/modules/viewer/fields/FieldsBreadcrumbs";
import OrdersBreadcrumbs from "@/modules/viewer/orders/OrdersBreadcrumbs";
import VisitorsBreadcrumbs from "@/modules/viewer/visitors/VisitorsBreadcrumbs";
import CarsDetail from "../cars/pages/Detail"
import OrdersDetail from "../orders/pages/Detail"
import VisitorsDetail from "../visitors/pages/Detail"
import OrganizationsBreadcrumbs from "@/modules/viewer/organizations/OrganizationsBreadcrumbs";
import OrdersFile from "@/modules/viewer/orders/pages/File";


export default ([
    {
        path: "/viewer",
        name: names.MAIN,
        component: Breadcrumbs,
        meta: {
            breadcrumb: "Наблюдатель",
            requiredAuth: true,
            instances: [
                PASS_ORDER_INSTANCE,
                ACCOUNTS_INSTANCE,
                EVENTCHAIN_INSTANCE
            ]
        },
        children: [
            {
                path: "cars",
                name: names.CARS.LIST,
                component: CarsBreadcrumbs,
                meta: {
                    breadcrumb: "Автомобили",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE
                    ]
                },
                children: [
                    {
                        path: ":idCars",
                        name: names.CARS.DETAIL,
                        component: CarsDetail,
                        meta: {
                            breadcrumb: "Детальное представление",
                            requiredAuth: true,
                            instances: [
                                PASS_ORDER_INSTANCE,
                                ACCOUNTS_INSTANCE
                            ]
                        }
                    }
                ]
            },
            {
                path: "fields",
                name: names.FIELDS.LIST,
                component: FieldsBreadcrumbs,
                meta: {
                    breadcrumb: "Списки полей сведений",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE
                    ]
                }
            },
            {
                path: "orders",
                name: names.ORDERS.LIST,
                component: OrdersBreadcrumbs,
                meta: {
                    breadcrumb: "Заявки",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE
                    ]
                },
                children: [
                    {
                        path: "file/:idFile",
                        name: names.ORDERS.FILE,
                        component: OrdersFile,
                        meta: {
                            breadcrumb: "Файл",
                            requiredAuth: true,
                            instances: [
                                PASS_ORDER_INSTANCE,
                                ACCOUNTS_INSTANCE,
                                PLACES_INSTANCE
                            ]
                        }
                    },
                    {
                        path: ":idOrders",
                        name: names.ORDERS.DETAIL,
                        component: OrdersDetail,
                        meta: {
                            breadcrumb: "Детальное представление",
                            requiredAuth: true,
                            instances: [
                                PASS_ORDER_INSTANCE,
                                ACCOUNTS_INSTANCE
                            ]
                        }
                    }
                ]
            },
            {
                path: "visitors",
                name: names.VISITORS.LIST,
                component: VisitorsBreadcrumbs,
                meta: {
                    breadcrumb: "Посетители",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE
                    ]
                },
                children: [
                    {
                        path: ":idVisitors",
                        name: names.VISITORS.DETAIL,
                        component: VisitorsDetail,
                        meta: {
                            breadcrumb: "Детальное представление",
                            requiredAuth: true,
                            instances: [
                                PASS_ORDER_INSTANCE,
                                ACCOUNTS_INSTANCE
                            ]
                        }
                    }
                ]
            },
            {
                path: "organizations",
                name: names.ORGANIZATIONS.LIST,
                component: OrganizationsBreadcrumbs,
                meta: {
                    breadcrumb: "Организации",
                    requiredAuth: true,
                    instances: [
                        PASS_ORDER_INSTANCE,
                        ACCOUNTS_INSTANCE
                    ]
                }
            }
        ]
    }
])
